// ═══════════════════════════════════════════════════════════════════
//  composants/StatCard.js
//  StatCard
// ═══════════════════════════════════════════════════════════════════

import { THEME } from "../socle/theme";

// ═══════════════ Composants & styles partagés ═══════════════
export function StatCard({ label, value, color, icon }) {
  return (
    <div style={{background:THEME.panel,border:`1px solid ${THEME.border}`,borderRadius:12,padding:14}}>
      <div style={{color:THEME.textMuted,fontSize:11,textTransform:"uppercase",letterSpacing:1}}>{icon} {label}</div>
      <div style={{color:color||THEME.text,fontSize:22,fontWeight:800,marginTop:4}}>{value}</div>
    </div>
  );
}
